import React from "react";
import { TMDB_IMG_BASE_URL } from "../utils/constants";

const MovieList = ({ title, movies }) => {
  return (
    <div>
      <h1 className="p-3 md:text-2xl">{title}</h1>
      <div className="movie-list flex overflow-x-scroll">
        {movies.map((movie) => (
          <img
            className="p-2 w-36 md:w-52"
            src={TMDB_IMG_BASE_URL + movie.poster_path}
          />
        ))}
      </div>
    </div>
  );
};

export default MovieList;
